/**
 * Converts a plain params object into a URL query string.
 *
 * - Skips null / undefined / empty-string values
 * - Repeats the key for array values  (?tags=a&tags=b)
 * - Returns a leading-`?` string, or '' when there are no params
 */
export function buildQueryString(params: object): string {
  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === '') continue;

    if (Array.isArray(value)) {
      for (const item of value) {
        if (item !== undefined && item !== null && item !== '') {
          searchParams.append(key, String(item));
        }
      }
      continue;
    }

    searchParams.append(key, String(value));
  }

  const query = searchParams.toString();
  return query ? `?${query}` : '';
}
